import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
// import { Card, CardActionArea, CardMedia } from '@material-ui/core';
import Grid from "@material-ui/core/Grid";
import SaveIcon from "@material-ui/icons/Save";
// import { Delete, CloseOutlined } from "@material-ui/icons/";
import { Formik, Form, yupToFormErrors } from "formik";
import * as Yup from "yup";
// import ModalFrame from "../../biztran_controls/Modal_Frame";
import Moment from "moment";
// import CreateMultipleDates from "./CreateMultipleDates"
import BiztranControls from "../../biztran_controls/BiztranControls";
import BiztranControlsFormik from "../../biztran_controls_formik/BiztranControlsFormik";
import UseFetchData from "../../../hooks/UseFetchData";
import transitions from "@material-ui/core/styles/transitions";
import { set } from "react-hook-form";


const EditProduct = (props) => {
  const classes = useStyles();
  const [response, fetchData] = UseFetchData();
  const [isOpen, setOpen] = useState(false);
  const [Mode, setMode] = useState('');
  const [RemainQuantity, setRemainQuantity] = useState('');
  const [DeliveryDate, setDeliveryDate] = useState();
  const [DeliveryDate1, setDeliveryDate1] = useState();
  const [DeliveryDate2, setDeliveryDate2] = useState();
  const [DeliveryDate3, setDeliveryDate3] = useState();
  const [Quantity, setQuantity] = useState();
  const [Quantity1, setQuantity1] = useState();
  const [Quantity2, setQuantity2] = useState();
  const [Quantity3, setQuantity3] = useState();
  const [TotalQuantity, setTotalQuantity] = useState("");
  const [Productresponse, FetchProduct] = UseFetchData();

  const validationSchema = Yup.object({
    Productresponse: Yup.string().required("Required!"),
    Quantity: Yup.string().required("Required!"),
    DeliveryDate: Yup.string().required("Required!")
  });



  const AddNew = () => {
    setOpen(true);
    // setProductSKUID('');
    setMode('Insert');
  };



  const onSub = () => {
    // debugger;
    var bodyFormData = new FormData();
    bodyFormData.append("QuotationDtlsID", props.QuotationdtldID);
    bodyFormData.append("Quantity", Quantity);
    bodyFormData.append("DeliveryDate", DeliveryDate);
    // bodyFormData.append("Quantity",TotalQuantity);
    // bodyFormData.append("RemainQuantity",RemainQuantity);
    fetchData("Quotation/AddProduct", bodyFormData);
  };

  useEffect(() => {
    if (response.Response === true) {
      alert("Data Saved Succesfully.");
      props.setOpen(false);
      // props.getByIDData()
    } else if (response.Response === false) {
      if (response.Message.includes("Already") === true) {
        alert(response.Message);
      } else {
        alert("Failed.");
      }
    }
  }, [response]);

  const PopulateData = () => {
    var bodyFormData = new FormData();
    // debugger;
    bodyFormData.append("QuotationdtlsID", props.QuotationdtldID);
    FetchProduct("Quotation/QuotationDtlsByID", bodyFormData);
  };

  useEffect(() => {
    PopulateData();
  }, []);

  useEffect(() => {
    // debugger;
    if (Productresponse.length > 0) {
      setQuantity(Productresponse[0].Quantity);
      setQuantity1(Productresponse[0].Quantity1);
      setQuantity2(Productresponse[0].Quantity2);
      setQuantity3(Productresponse[0].Quantity3);
      setTotalQuantity(Productresponse[0].Quantity);
      setRemainQuantity(Productresponse[0].RemainQuantity);
      setDeliveryDate(Moment(Productresponse[0].DeliveryDate).format("YYYY-MM-DD"));
      setDeliveryDate1(Moment(Productresponse[0].DeliveryDate1).format("YYYY-MM-DD"));
      setDeliveryDate2(Moment(Productresponse[0].DeliveryDate2).format("YYYY-MM-DD"));
      setDeliveryDate3(Moment(Productresponse[0].DeliveryDate3).format("YYYY-MM-DD"));
    }
  }, [Productresponse]);


  useEffect(() => {
    // debugger;
    setRemainQuantity(TotalQuantity - Quantity);
  }, [RemainQuantity, Quantity]);


  return (
    <div>
      <Formik
        initialValues={{
          TotalQuantity: TotalQuantity,
          Quantity: Quantity,
          RemainQuantity: RemainQuantity,
          DeliveryDate: DeliveryDate
        }}
        validationSchema={validationSchema}
        // onSubmit={onSubmit}
        enableReinitialize
      >
        {(formik) => {
          return (
            <Form>
              {/* <Typography className={classes.headertext} noWrap>Add Product</Typography> */}
              <Grid spacing={1} container direction="row" >
                <Grid spacing={1} item xs={8} container>
                  <Grid item xs={6}>
                    <BiztranControlsFormik
                      control="input"
                      type="text"
                      label="Total Quantity Order"
                      name="TotalQuantity"
                      disabled
                      onChange={(e) => setTotalQuantity(e.target.value)}
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <BiztranControlsFormik
                      control="input"
                      type="text"
                      label="Remain Quantity"
                      name="RemainQuantity"
                      disabled
                      onChange={(e) => setTotalQuantity(e.target.value)}
                    />
                  </Grid>
                </Grid>
                <Grid spacing={1} container direction="row" >
                  <Grid item xs={12} md={2} sm={4} lg={2} xl={2} >
                    <BiztranControlsFormik
                      control="input"
                      type="text"
                      label="Quantity"
                      name="Quantity"
                      onChange={(e) => setQuantity(e.target.value)}
                    />
                  </Grid>
                  <Grid item xs={12} md={2} sm={4} lg={4} xl={2} >
                    <BiztranControlsFormik
                      control="input"
                      type="date"
                      label="DeliveryDate"
                      name="DeliveryDate"
                      onChange={(e) => setDeliveryDate(e.target.value)}
                    />
                  </Grid>
                  <Grid item xs={12} md={2} sm={4} lg={2} xl={2} >
                    <BiztranControlsFormik
                      control="input"
                      type="text"
                      label="Quantity1"
                      name="Quantity1"
                      onChange={(e) => setQuantity1(e.target.value)}
                    />
                  </Grid>
                  <Grid item xs={12} md={2} sm={4} lg={4} xl={2} >
                    <BiztranControlsFormik
                      control="input"
                      type="date"
                      label="DeliveryDate1"
                      name="DeliveryDate1"
                      // defaultValue={DeliveryDate}
                      onChange={(e) => setDeliveryDate1(e.target.value)}
                    />
                  </Grid>
                  <Grid item xs={12} md={2} sm={4} lg={2} xl={2} >
                    <BiztranControlsFormik
                      control="input"
                      type="text"
                      label="Quantity2"
                      name="Quantity2"
                      onChange={(e) => setQuantity2(e.target.value)}
                    />
                  </Grid>
                  <Grid item xs={12} md={2} sm={4} lg={4} xl={2} >
                    <BiztranControlsFormik
                      control="input"
                      type="date"
                      label="DeliveryDate2"
                      name="DeliveryDate2"
                      // defaultValue={DeliveryDate}
                      onChange={(e) => setDeliveryDate2(e.target.value)}
                    />
                  </Grid>
                  <Grid item xs={12} md={2} sm={4} lg={2} xl={2} >
                    <BiztranControlsFormik
                      control="input"
                      type="text"
                      label="Quantity3"
                      name="Quantity3"
                      onChange={(e) => setQuantity3(e.target.value)}
                    />
                  </Grid>
                  <Grid item xs={12} md={2} sm={4} lg={4} xl={2} >
                    <BiztranControlsFormik
                      control="input"
                      type="date"
                      label="DeliveryDate3"
                      name="DeliveryDate3"
                      // defaultValue={DeliveryDate}
                      onChange={(e) => setDeliveryDate3(e.target.value)}
                    />
                  </Grid>
                </Grid>
              </Grid>
              <Grid spacing={2} container direction="row">
                <Grid item xs={12}>
                  <div style={{ width: '100%' }}>
                    <div style={{ display: 'flex', justifyContent: 'center', alignContent: "center" }}>
                      <BiztranControls.Button
                        text="Updates"
                        type="submit"
                        onClick={() => {
                          onSub();
                        }}
                        startIcon={<SaveIcon />}
                      />
                    </div>
                  </div>
                </Grid>
              </Grid>
            </Form>
          );
        }}
      </Formik>
    </div>
  );
};
const useStyles = makeStyles((theme) => ({
  headertext: {
    background: "#e6d8d8", //theme.palette.tertiary.gradient,
    color: "#3d3d3d",
    height: "2rem",
    paddingLeft: "30px",
    fontSize: "1.5rem",
    marginTop: "-16px",
    marginBottom: "10px",
    marginLeft: "-24px",
    marginRight: "-24px",
    //   borderRadius: "1rem",
  },
  root: {
    height: '100%',
    width: '100%',
    paddingTop: '7%',
    //paddingTop: '56.25%', // 16:9
  },
}));

export default EditProduct;
